import React, { useEffect, useState } from 'react';
import RedirectComp from './RedirectComp';
import UilSetting from '@iconscout/react-unicons/icons/uil-setting';
import { useSelector } from 'react-redux';
import { selectRoles } from 'features/roles/rolesSlice';
import { isMobile } from 'react-device-detect';
import { getUserFromViewedUser } from 'helpers/generic.methods';
import TourWrapper from './TourWrapper';
import PopMenu from './popmenu';
import useViewport from 'helpers/viewport-hook';

const SideBarBottom = ({ user, showSideBar, switchTo, setShowSidebar }) => {
  const [showChat, setShowChat] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [loginDetails, setLoginDetails] = useState(null);

  const { roles } = useSelector(selectRoles);
  const screen = useViewport();

  useEffect(() => {
    let loggedInUser = getUserFromViewedUser();
    if (loggedInUser) {
      setLoginDetails(loggedInUser);
    }
  }, [showChat]);

  const [toggleTour, setToggleTour] = useState(false);

  const toggelTourHandler = value => {
    setToggleTour(value);
  };

  const onChangeHandler = stepIndex => {
    if (roles.analytics.view && isMobile && stepIndex === 0) {
      setShowSidebar(false);
    } else {
      setShowSidebar(true);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (loginDetails && !loginDetails?.isLogginBefore) {
        setModalShow(true);
        setShowSidebar(true);
      } else {
        setModalShow(false);
      }
    }, 3000);
  }, [loginDetails]);

  useEffect(() => {
    if (toggleTour && isMobile) {
      document.body.className = 'body-wrapper';
    } else {
      document.body.className = '';
    }
  });

  return (
    <div
      className="sidebar-bottom-wrap"
      style={{ width: '100%', left: !screen?.xs && '0' }}
    >
      {/* <PreloadImages imgSource={dropdownEnums.enum_ImageSource} /> */}
      <TourWrapper
        tourModalShow={modalShow}
        setModalShow={setModalShow}
        toggelTourHandler={toggelTourHandler}
        toggleTour={toggleTour}
        onTourChange={onChangeHandler}
      />

      {switchTo.allowPortal ? <RedirectComp showSideBar={showSideBar} /> : null}
      {roles.settings.view && (
        <PopMenu
          id={'introJS-item-setting'}
          showSideBar={showSideBar}
          title={'Settings'}
          path="/portal/settings/widget-editor"
          icon={<UilSetting size="24" className="sidebar-link" />}
          showTooltip={false}
          // clickHandler={e => history.push('/portal/settings/widget-editor')}
          clickHandler={e =>
            screen?.xs
              ? setShowSidebar(!showSideBar)
              : console.log('clickHandler')
          }
        />
      )}
    </div>
  );
};

export default SideBarBottom;
